const billTableColumns = [
  { label: "Status", value: "status" },
  { label: "Cód. Fatura", value: "number" },
  { label: "Agrupado por", value: "groupable_display_name" },
  { label: "Filial da empresa", value: "company_branch" },
  { label: "Valor gasto neste empenho", value: "movements_total_in_bill" },
  { label: "Vlr. Total", value: "total_amount", className: "text-green-400" },
  { label: "N. Transações", value: "events_count" },
  { label: "Período", value: "period" },
  { label: "Abertura", value: "opened_at" },
  { label: "Fechamento", value: "closed_at" },
  { label: "Vencimento", value: "due_at" },
  { label: "Ações", value: "actions", className: "w-9" },
];

export default billTableColumns;

export const governmentAllocationBillsTableColumns = billTableColumns.filter(({ value }) => ![
  'company_branch',
].includes(value));
